import script from "./employee.vue?vue&type=script&setup=true&lang=js"
export * from "./employee.vue?vue&type=script&setup=true&lang=js"

import "./employee.vue?vue&type=style&index=0&id=05ece273&lang=scss"

const __exports__ = script;

export default __exports__